<template>
  <div class="tab-contents">
    <div :class="['tab-content', {active: isActive}]">
      <template v-if="__userList.length > 0">
        <WinnersHistoryItem
          v-for="(item, index) in __userList"
          :key="`${winnersHistory.type}_${item.msisdn}`"
          :type="winnersHistory.type"
          :item="item"
          :animated="index >= INITIAL_VISIBLE_ITEMS"
        />

        <LoadMoreButton
          :is-visible="hasMoreItems"
          @click:loadMore="handleLoadMore"
        />
      </template>

      <p v-else class="no_winners">
        {{ $_translations.value.page_get_started_section_winners_no_winners }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import WinnersHistoryItem from '@/views/getStarted/components/WinnersHistoryItem.vue';
import LoadMoreButton from '@/components/button/LoadMoreButton.vue';

const INITIAL_VISIBLE_ITEMS = 2;

const props = defineProps({
  isActive: {
    type: Boolean,
    default: false,
  },
  winnersHistory: {
    type: Object,
    default: () => ({}),
  },
});

const isListExpanded = ref(false);

const __userList = computed(() => isListExpanded.value ? props.winnersHistory.userList : props.winnersHistory.userList.slice(0, INITIAL_VISIBLE_ITEMS));

const hasMoreItems = computed(() => {
  return ( props.winnersHistory.userList.length > INITIAL_VISIBLE_ITEMS) &&
    !isListExpanded.value;
});

const handleLoadMore = () => {
  isListExpanded.value = true;
};
</script>
